import React, { ReactNode, SyntheticEvent } from 'react';

import SOCIAL from '../../constants/social';
import isMobile from '../../utils/isMobile';
import { withTrack, WithTrack } from '../../utils/analytics';
import { captureException } from '@sentry/browser';

// TODO social_utm_term on all social tracking? campaign does it?

export type MessengerShareProps = WithTrack & {
  children: ReactNode;
  url: string;
  className?: string;
  trackingData: Record<string, any>;
};

export class MessengerShare extends React.PureComponent<MessengerShareProps> {
  onClick = (event: SyntheticEvent) => {
    const { track, trackingData } = this.props;
    track(trackingData);

    if (!isMobile(window)) {
      event.preventDefault();
      FB.ui(
        {
          method: 'send',
          link: this.props.url,
        },
        response => {
          if (response.error_message || response.error_code) {
            captureException({
              facebookErrorCode: response.error_code,
              facebookErrorMessage: response.error_message,
            });
          }
        },
      );
    }
  };

  render() {
    const { children, className, url } = this.props;

    return (
      <a
        data-qa="messenger-btn"
        onClick={this.onClick}
        className={`jg-btn jg-btn--messenger ${className}`}
        href={`fb-messenger://share/?link=${url}&app_id=${SOCIAL.FB_APP_ID}`}
      >
        {children}
      </a>
    );
  }
}

export default withTrack(MessengerShare);
